// import { Outlet } from 'react-router';
import type { RouteObject } from 'react-router';
import * as CFG from '@siloreal:app:config';
import * as UI from '@siloreal:shared:ui';
import NotFoundPage from '@old/pages/public/not-found';
import { ErrorScreen } from '@old/navigation/error-screen';
import { ProtectedRoute } from '@old/navigation/protected-routes';
// import { TempForm } from './temp-form';
// import { TempTable } from './temp-table';
// import { TempLogin } from './temp-login';
import { Providers } from '@siloreal:app:providers/providers';
import { SilobagList } from '@siloreal:modules:private/silobag-list/silobag-list';

export const newRoutes: RouteObject[] = [
  {
    id: 'new-root',
    element: <Providers />,
    errorElement: <ErrorScreen />,
    children: [
      // {
      //   id: 'new-public-layout',
      //   element: (
      //     <UI.layout.pub>
      //       <Outlet />
      //     </UI.layout.pub>
      //   ),
      //   errorElement: <ErrorScreen />,
      //   children: [
      //     {
      //       id: 'new-public-auth-siloreal-login',
      //       path: CFG.PATH.AUTH_SILOREAL_LOGIN,
      //       element: <TempLogin />,
      //       errorElement: <ErrorScreen />,
      //     },
      //     {
      //       id: 'new-public-dev-login',
      //       path: '/dev/login',
      //       element: <TempLogin />,
      //       errorElement: <ErrorScreen />,
      //     },
      //   ],
      // },
      {
        id: 'new-private-auth',
        element: <ProtectedRoute />,
        errorElement: <ErrorScreen />,
        children: [
          {
            id: 'new-private-legacy-layout',
            element: <UI.layout.priv legacy withHeader withFooter withSideSpaces />,
            errorElement: <ErrorScreen />,
            children: [
              {
                id: 'silobag-list',
                path: CFG.PATH.SILOBAG_LIST,
                element: <SilobagList />,
                errorElement: <ErrorScreen />,
              },
              // {
              //   id: 'new-private-dev-playground',
              //   path: '/dev/playground',
              //   element: <TempForm />,
              //   errorElement: <ErrorScreen />,
              // },
              // {
              //   id: 'new-private-dev-table',
              //   path: '/dev/table',
              //   element: <TempTable />,
              //   errorElement: <ErrorScreen />,
              // },
            ],
          },
        ],
      },
      {
        id: 'new-not-found',
        path: '*',
        element: <NotFoundPage />,
        errorElement: <ErrorScreen />,
      },
    ],
  },
];
